module.exports = __webpack_public_path__ + "static/media/moreBsc.7a1557ed.png";